import React from "react";
import { Card, Col, Container, ListGroup, Row } from "react-bootstrap";
import { FaQuoteLeft } from "react-icons/fa";
import { FaQuoteRight } from "react-icons/fa";
import { SiTicktick } from "react-icons/si";
import BG from "../assets/Blue.png";
import Image from "../assets/IAM-Advisory-3.png";
import Footer from "../components/Footer";
import "../utils/effectCSS/Effects.css";

const IdentityGovernanceandAdministration = () => {
  return (
    <>
      <Container
        fluid
        className="py-5"
        style={{
          backgroundImage: "url(" + BG + ")",
        }}
      >
        <div
          style={{
            height: "70px",
          }}
        ></div>
        <h2 className="text-center p-4">
          <b>Identity Governance and Administration</b>
        </h2>

        <hr
          className="d-flex justify-content-center"
          style={{
            width: "10%",
            border: "1.5px solid blue",
            margin: "0 auto",
          }}
        />

        <div className="mt-5">
          <Row>
            <Col lg={2} className="d-flex justify-content-end">
              <FaQuoteLeft
                style={{
                  color: "#00FFFF",
                  fontSize: "25px",
                }}
              />
            </Col>

            <Col lg={8}>
              <Container fluid className="text-center">
                <p
                  style={{
                    fontSize: "1.25rem",
                  }}
                >
                  Conquer the complexities of Identity Governance and
                  Administration (IGA) with IDM `360’s Expert Guidance and
                  Services. Streamline Processes, Enhance Security, and Achieve
                  Compliance while effectively navigating challenges such as
                  Cost, Data Management, and User Resistance.
                </p>
              </Container>
            </Col>

            <Col
              lg={2}
              className="d-flex align-items-start justify-content-start"
            >
              <FaQuoteRight
                style={{
                  color: "#00FFFF",
                  fontSize: "25px",
                }}
              />
            </Col>
          </Row>
        </div>
        <Container>
          <Row className="mt-5 align-items-stretch">
            <Col className="d-flex" lg={6} xs={12}>
              <img className="img-fluid" src={Image} alt="IAM" />
            </Col>
            <Col className="d-flex" lg={6} xs={12}>
              <Container
                style={{
                  backgroundColor: "#6495ED",
                  color: "white",
                  padding: "5rem 4rem",
                }}
              >
                <h3 className="">Implementing a successful IGA program</h3>

                <div className="mt-4">
                  <ListGroup className="border-0 bg-transparent ">
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      Identity Governance Framework Design
                    </ListGroup.Item>
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      Access Policy Implementation
                    </ListGroup.Item>
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      Automated Identity Lifecycle Management
                    </ListGroup.Item>
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      Role-Based Access Control (RBAC) Strategy
                    </ListGroup.Item>
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      User Access Certification & Provisioning
                    </ListGroup.Item>
 		    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      Identity Access Auditing and Reporting
                    </ListGroup.Item>
		    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      IGA Workflow Automation and Optimization
                    </ListGroup.Item>
                  </ListGroup>
                </div>
              </Container>
            </Col>
          </Row>
        </Container>
        <Card className="bg-transparent border border-0 text-black p-5 text-center">
          <Card.Body>
            <h3 className="text-center mb-4">
              <b>Confidently implement IGA with the expertise of IDM 360 Analytics</b>
            </h3>
            <hr
              className="d-flex justify-content-center"
              style={{
                width: "10%",
                border: "1.5px solid blue",
                margin: "0 auto",
              }}
            />
            <Container>
              <Row xs={1} lg={3}>
                <Col lg={2}></Col>
                <Col lg={8} className="mt-4">
                  <p
                    style={{
                      fontSize: "1.25rem",
                    }}
                  >
                    IDM 360 Analytics' comprehensive IGA services tackle challenges
                    head-on. We understand the complexities of integrating
                    diverse systems and cleansing messy data, and our experts
                    guide you through every step. We identify and implement
                    user-friendly tools with intuitive interfaces to minimize
                    resistance to change. Additionally, Our Training and Support
                    programs equip your Team with the skills needed to manage
                    the IGA system effectively.
                  </p>
                </Col>
                <Col lg={2}></Col>
              </Row>
            </Container>
          </Card.Body>
        </Card>

        <Container className="p-0">
          {/* First Row */}
          <Row className="justify-content-center g-3 align-items-stretch">
            <Col lg={4} className="d-flex hover-left">
              <Container
                className="flex-fill text-center"
                style={{
                  padding: "4rem",
                  backgroundColor: "#3457D5",
                  color: "white",
                }}
              >
                <h5>IGA Advisory</h5>
              </Container>
            </Col>

            <Col lg={6} className="d-flex hover-right">
              <Container
                className="flex-fill border border-1 shadow-lg"
                style={{
                  padding: "2rem",
                  backgroundColor: "white",
                  fontSize: "13px",
                }}
              >
                <p>
                  IDM 360 Analytics provides expert IGA advisory services to
                  simplify the complexities of IGA Implementation and
                  Optimization. Our consultants work closely with you to
                  understand your unique challenges, delivering a tailored
                  strategy that aligns with your Business goals and Ensures
                  Sustainable Growth.
                </p>
              </Container>
            </Col>
          </Row>
          {/* Second Row */}
          <Row className="justify-content-center g-3 mt-1 align-items-stretch">
            <Col lg={6} className="d-flex order-2 order-lg-1 hover-left">
              <Container
                className="flex-fill border border-1 shadow-lg"
                style={{
                  padding: "2rem",
                  backgroundColor: "white",
                  fontSize: "13px",
                }}
              >
                <p>
                  IDM 360 Analytics is your trusted partner, charting a tailored
                  path for your IGA journey. We help you select the Right Tools,
                  Establish Secure Environments, and Implement clear processes
                  and policies. Our Experts provide change management strategies
                  and navigate evolving compliance requirements, with continuous
                  support to adapt and overcome new challenges.
                </p>
              </Container>
            </Col>

            <Col lg={4} className="d-flex order-1 order-lg-2 hover-right">
              <Container
                className="flex-fill text-center"
                style={{
                  padding: "4rem",
                  backgroundColor: "#1ca9c9",
                  color: "white",
                }}
              >
                <h5>IGA Implementation</h5>
              </Container>
            </Col>
          </Row>

          {/* Third Row */}
          <Row className="justify-content-center g-3 mt-1 align-items-stretch">
            <Col lg={4} className="d-flex hover-left">
              <Container
                className="flex-fill text-center"
                style={{
                  padding: "4rem",
                  backgroundColor: "#3457D5",
                  color: "white",
                }}
              >
                <h5>Program Support & Maintenance</h5>
              </Container>
            </Col>

            <Col lg={6} className="d-flex hover-right">
              <Container
                className="flex-fill border border-1 shadow-lg"
                style={{
                  padding: "2rem",
                  backgroundColor: "white",
                  fontSize: "13px",
                }}
              >
                <p>
                  Implementing an IGA program is only the beginning. Sustaining
                  its effectiveness and evolving with changing needs is key to
                  achieving long-term IAM success. IDM 360 Analytics offers
                  expert support and maintenance services to guide you every
                  step of the way, ensuring your IGA program performs at its
                  peak and stays ahead of future challenges.
                </p>
              </Container>
            </Col>
          </Row>
        </Container>
      </Container>
      <div className="mt-4">
        <Footer />
      </div>
    </>
  );
};

export default IdentityGovernanceandAdministration;
